var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 40C31.0461 40 40.0004 31.0457 40.0004 20C40.0004 8.95435 31.0461 4.57764e-05 20.0004 4.57764e-05C8.95467 4.57764e-05 0.000366211 8.95435 0.000366211 20C0.000366211 31.0457 8.95467 40 20.0004 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 20C40.0002 11.4008 34.5727 4.06985 26.9567 1.24406V38.7562C34.5727 35.9302 40.0002 28.5994 40.0002 20V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 20C6.10352e-05 28.5994 5.42756 35.9302 13.0436 38.7561V1.24406C5.42756 4.06985 6.10352e-05 11.4008 6.10352e-05 20V20Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeru);
export default __webpack_public_path__ + "static/media/peru.888033c4674ec0da5fe2fe19031c2caa.svg";
export { ForwardRef as ReactComponent };